<div class=" flex-center-center flex-direction-column" style="margin: 20px">
  <div class="logo" style="margin-bottom: 10px">
    <a routerLink="/auth/login"><img [src]="logo" width="150px"></a>
  </div>
  <app-template-form
    subtitle="{{'compile' | translate}} ({{ 'mandatory_field' | translate}})"
    style="width: 800px;max-width: 100%">
    <form [formGroup]="userForm" (submit)="save()">
      <mat-form-field floatLabel="auto" appearance="fill" class="w100">
        <mat-label>{{ 'name' | translate}}</mat-label>
        <input matInput id="name"
          formControlName="name">
        <!--        <mat-error *ngIf="userForm.get('name').invalid">{{ 'mandatory_field_message' | translate}}</mat-error>-->
      </mat-form-field>
      <mat-form-field floatLabel="auto" appearance="fill" class="w100">
        <mat-label>{{ 'surname' | translate}}</mat-label>
        <input matInput
          formControlName="surname">
        <!--        <mat-error *ngIf="userForm.get('name').invalid">{{ 'mandatory_field_message' | translate}}</mat-error>-->
      </mat-form-field>
      <!--            <mat-form-field floatLabel="auto" appearance="fill" class="w100">-->
      <!--                <mat-label>{{ 'phone' | translate}}</mat-label>-->
      <!--                <input matInput id="phone"-->
      <!--                       formControlName="phone">-->
    <!--            </mat-form-field>-->
    <!--            <mat-form-field floatLabel="auto" appearance="fill" class="w100">-->
    <!--                <mat-label>{{ 'old_password' | translate}}</mat-label>-->
    <!--                <input matInput id="password" formControlName="old_password" required-->
    <!--                       [type]="hide ? 'password': 'text'">-->
    <!--                <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>-->
    <!--                &lt;!&ndash;        <mat-error *ngIf="userForm.get('password').invalid">{{ 'mandatory_field_message' | translate}}</mat-error>&ndash;&gt;-->
  <!--            </mat-form-field>-->
  <mat-form-field floatLabel="auto" appearance="fill" class="w100">
    <mat-label>{{ 'password' | translate}}</mat-label>
    <input matInput
      id="confirm_password"
      required
      [type]="hide2 ? 'password': 'text'"
      formControlName="new_password"
      >
    <mat-icon matSuffix (click)="hide2 = !hide2">{{hide2 ? 'visibility_off' : 'visibility'}}</mat-icon>
  </mat-form-field>
  @if ((errorsTwoPassIsEquals$|async)) {
    <mat-error>{{ 'passwordIsEquals' | translate}}
    </mat-error>
  }

  <!--            <div class="spacer">-->
  <!--                <mat-checkbox id="privacy" formControlName="privacy" name="privacy">-->
  <!--                    *{{ 'privacy_declaration' | translate}}-->
  <!--                    <a-->
  <!--                            mat-icon-button-->
  <!--                            color="primary"-->
  <!--                            style="text-decoration: underline"-->
  <!--                            target="_blank"-->
<!--                            href="https://huna.io/privacy-policy">{{ 'privacy' |translate}}</a>-->
<!--                </mat-checkbox>-->

<!--                &lt;!&ndash;        <mat-error *ngIf="userForm.get('privacy').invalid">{{ 'accept' | translate}}*</mat-error>&ndash;&gt;-->
<!--            </div>-->
<!--            <div class="spacer">-->
<!--                <mat-checkbox-->
<!--                        id="conditions" formControlName="conditions" name="conditions">-->
<!--                    *{{ 'conditions_declaration' | translate}}-->
<!--                    <a-->
<!--                            mat-icon-button-->
<!--                            color="primary"-->
<!--                            href="https://huna.io/termini-e-condizioni"-->
<!--                            style="text-decoration: underline"-->
<!--                            target="_blank">{{ 'conditions' | translate}}</a>-->
<!--                </mat-checkbox>-->
<!--                &lt;!&ndash;        <mat-error *ngIf="userForm.get('conditions').invalid">{{ 'accept' | translate}}*</mat-error>&ndash;&gt;-->
<!--            </div>-->
<div class="spacerh5"></div>
<app-huna-button [loading]="loading">
  <button mat-flat-button color="primary" class="w100" type="submit"
    [disabled]="(errorsForm$|async)">{{ 'save' | translate}}
  </button>
</app-huna-button>

</form>
</app-template-form>
</div>
